import React from 'react';

/**
 * Haul hours on a delivery or a return (rentals-haul item 5, api#1054): the
 * hours the truck spent on this trip, billed at the price book's hourly haul
 * rate. Optional — blank is "not recorded" (the office can add it later), and
 * an explicit 0 is a real 0. The API checks the range (0–999.99) and its
 * refusal is shown as sent. Offered only when the company bills hauls by the
 * hour and the dispatch names a truck: no truck, no haul line.
 */
export function HaulHoursField({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  return (
    <div className="bg-fieldiq-card border border-fieldiq-border rounded-xl p-4" data-testid="haul-hours-field">
      <label htmlFor="haul-hours" className="block text-xs font-bold text-fieldiq-muted uppercase tracking-wider mb-2">
        Haul hours
      </label>
      <input
        id="haul-hours"
        type="number"
        inputMode="decimal"
        min="0"
        max="999.99"
        step="0.25"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="e.g. 3.5"
        className="w-full bg-fieldiq-dark border border-fieldiq-border rounded-lg px-3 py-3 text-sm text-white placeholder-fieldiq-muted min-h-[48px]"
      />
      <p className="text-xs text-fieldiq-muted mt-1">The truck's hours for this trip. Leave blank if you don't know.</p>
    </div>
  );
}

/** The `haul_hours` key for a deliver / return body: absent when blank, else the number typed. */
export function haulHoursBody(value: string): { haul_hours?: number } {
  return value.trim() === '' ? {} : { haul_hours: Number(value) };
}
